import { motion } from "framer-motion";
import { useState, useEffect } from "react";

export default function Stats() {
  const [counters, setCounters] = useState({
    saving: 0,
    customers: 0,
    installations: 0,
    co2: 0,
  });

  const stats = [
    { label: "Energy Savings", value: 90, suffix: "%", icon: "⚡" },
    { label: "Happy Customers", value: 3, suffix: "K+", icon: "👥" },
    { label: "Installations", value: 2, suffix: "K+", icon: "🏠" },
    { label: "CO₂ Saved", value: 2.5, suffix: "M Tons", icon: "🌱" },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCounters((prev) => ({
        saving: Math.min(prev.saving + 1, 90),
        customers: Math.min(prev.customers + 0.4, 3),
        installations: Math.min(prev.installations + 15, 2),
        co2: Math.min(prev.co2 + 0.1, 2.5),
      }));
    }, 50);

    return () => clearInterval(interval);
  }, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.15 },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  return (
    <>
  
    <section className="py-20 bg-gradient-to-b from-black to-gray-900/50">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            By The Numbers
          </h2>
          <p className="text-white/60 text-lg max-w-2xl mx-auto">
            Proven impact from leading solar energy provider
          </p>
        </motion.div>

        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              variants={cardVariants}
              whileHover={{ y: -8 }}
              className="relative p-8 rounded-2xl bg-gradient-to-br from-orange-500/10 to-orange-600/5 border border-orange-500/20 group overflow-hidden"
            >
              {/* Gradient background on hover */}
              <div className="absolute inset-0 bg-gradient-to-br from-orange-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

              <div className="relative z-10">
                <div className="text-4xl mb-4">{stat.icon}</div>
                <motion.div
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ duration: 0.8 }}
                  viewport={{ once: true }}
                  className="text-5xl font-bold text-orange-400 mb-2"
                >
                  {/* Display appropriate counter */}
                  {index === 0 && Math.round(counters.saving)}
                  {index === 1 && counters.customers.toFixed(1)}
                  {index === 2 && Math.round(counters.installations)}
                  {index === 3 && counters.co2.toFixed(1)}
                  <span className="text-2xl ml-1">{stat.suffix}</span>
                </motion.div>
                <p className="text-white/70 font-medium">{stat.label}</p>
              </div>

              {/* Animated border */}
              <div className="absolute inset-0 rounded-2xl border border-orange-400/0 group-hover:border-orange-400/30 transition-all duration-300" />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
    </>
  );
}
